export default __webpack_public_path__ + "static/media/service-basic.a92c46c3.png";